import { TEMPLATES, TEMPLATE_CATEGORIES } from './templates.js';
import { PACKAGES, ADDONS } from './packages.js';

export const DEFAULT_CONFIG = {
  owner_email: '',
  owner_password: '',
  template_category: '',
  template: 'restaurant-v1',
  branding: {
    company_name: '',
    logo_url: '',
    logo_dataUrl: null,
    primary: '#3b82f6',
    secondary: '#6366f1',
    font: 'Inter',
  },
  content: {
    hero_headline: '',
    hero_sub: '',
    about: '',
    services: [],
    contact_email: '',
    contact_phone: '',
    address: '',
  },
  package: 'starter',
  addons: [],
  slug: '',
  custom_domain: '',
};

export const BUILD_STEPS = [
  { icon:'🔐', label:'Creating your account' },
  { icon:'🎨', label:'Applying your branding' },
  { icon:'🗂️', label:'Setting up your content' },
  { icon:'⚙️', label:'Configuring features' },
  { icon:'🌐', label:'Registering your domain' },
  { icon:'🔒', label:'Setting up SSL certificate' },
  { icon:'🚀', label:'Deploying your site' },
];

export function tmplById(id) {
  return TEMPLATES.find(t => t.id === id) || TEMPLATES[0];
}

export function pkgById(id) {
  return PACKAGES.find(p => p.id === id) || PACKAGES[0];
}

export function conceptForTemplate(templateId) {
  // Map template IDs to restaurant concepts for preview
  const pizzaIds = ['pizza-v1','cafe-v1'];
  if (pizzaIds.includes(templateId)) return 'pizza';
  return 'thai';
}

export function featuresForPackage(pkgId) {
  const pkg = pkgById(pkgId);
  return pkg ? pkg.features : [];
}
